import type { Routine } from '../../types/submit/Routine';
import { APICommunicator } from '~/api/APICommunicator';

export const createApplicantRoutine: Routine = async ({ aggregateId, data }) => {
    const response = await APICommunicator.apiFetch({
        context: {
            body: JSON.stringify({ aggregateId, data }),
            method: 'POST',
        },
        route: '/applicant/createApplicantRoutine',
    });

    return response.json();
};
